import React from 'react';
import '../styles/Links.css';

const Links: React.FC = () => {
  return (
    <div className="links-container">
      <div className="links-content">
        {/* <div className="links-images">
          <img 
            src={`${process.env.PUBLIC_URL}/images/photos/lampflower.jpg`} 
            alt="lamp and flower at Aaron Glen Guesthouse" 
            width="250" 
            height="370" 
          />
          <img 
            src={`${process.env.PUBLIC_URL}/images/photos/bar.jpg`} 
            alt="bar at Aaron Glen Guesthouse" 
            width="250" 
            height="168" 
          />
        </div> */}
        
        <div className="links-info">
          <p>
            <a href="http://www.tripadvisor.com/Hotel_Review-g186525-d581745-Reviews-Aaron_Glen_Guesthouse-Edinburgh_Scotland.html">
              Trip Advisor.com's reviews of Aaron Glen
            </a>
          </p>
          
          <p>
            Edinburgh Weather Forecast: 
            <a href="https://www.bbc.co.uk/weather/2650225">
            https://www.bbc.co.uk/weather/2650225
            </a>
          </p>

          <h2>Local activities</h2>

          <p>Gym and swimming facilities four minutes drive: 
            <a href="https://www.midlothian.gov.uk/info/200303/leisure_centres_and_pools/797/loanhead_leisure_centre_and_pool">https://www.midlothian.gov.uk/info/200303/leisure_centres_and_pools/797/loanhead_leisure_centre_and_pool</a>
          </p>
          <p>Coffee at our magical local Secret Herb Garden: 
            <a href="https://www.tiktok.com/@myveggietravels/video/7517711105255329046">https://www.tiktok.com/@myveggietravels/video/7517711105255329046</a>
          </p>
          <p>Adventure for speed lovers five minutes away at: 
            <a href="https://www.midlothian.gov.uk/info/200281/snowsports_centre/586/destination_hillend/2">https://www.midlothian.gov.uk/info/200281/snowsports_centre/586/destination_hillend/2</a>
          </p>
          <p>The Pentland Hills with Highland Cows and amazing views of Edinburgh five minutes drive 
            <a href="https://www.pentlandhills.org/">https://www.pentlandhills.org/</a>
          </p>
          <p>Europe’s longest dry ski slope with ski and snowboard hire: 
            <a href="https://www.midlothian.gov.uk/info/200281/snowsports_centre">https://www.midlothian.gov.uk/info/200281/snowsports_centre</a>
          </p>

          <h2>Edinburgh Festivals</h2>
          <p>Edinburgh International Festival: www.eif.co.uk: 
            <a href="http://www.eif.co.uk">http://www.eif.co.uk</a>
          </p>
          <p>Edinburgh Fringe Festival: 
            <a href="http://www.edfringe.com">http://www.edfringe.com</a>
          </p>
          <p>Edinburgh International Film Festival: 
            <a href="http://www.edfilmfest.org.uk">http://www.edfilmfest.org.uk</a>
          </p>
          <p>Edinburgh Book Festival: 
            <a href="http://www.edbookfest.co.uk">http://www.edbookfest.co.uk</a>
          </p>
          <p>All festivals coverage: 
            <a href="http://www.edinburgh-festivals.com">http://www.edinburgh-festivals.com</a>
          </p>

          <h2>Travel Sites</h2>
          <p>East coast train line London-Edinburgh: 
            <a href="http://www.nationalrail.co.uk/">http://www.nationalrail.co.uk/</a>
          </p>
          <p>West coast line via Glasgow: 
            <a href="http://www.virgintrains.co.uk">http://www.virgintrains.co.uk</a>
          </p>

          <h2>Airlines:</h2>
          <p>British Airways: 
            <a href="http://www.britishairways.com">http://www.britishairways.com</a>
          </p>
          <p>Easyjet: 
            <a href="http://www.easyjet.com">http://www.easyjet.com</a>
          </p>
          <p>Ryanair: 
            <a href="http://www.ryanair.com/">http://www.ryanair.com/</a>
          </p>

          <p>Other links:</p>
          <p>
            <a href="http://www.secretscotland.org.uk/" target="_blank">Secret Scotland</a>
          </p>
          <p>
            <a href="http://www.secret-scotland.com/">Secret Scotland holiday routes and accommodation guides</a>
          </p>
          <p>
            <a href="https://www.sallymooreglass.com" target="_blank">Sally Moore Glass</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Links; 